import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigApifySettings } from "./app-settings-config-apify";

export interface IConfigApifyInputState {
  showModal: boolean;
  editingApifyId: string;
}

export interface IConfigApifyInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigApifyInput extends PureComponent<IConfigApifyInputProps, IConfigApifyInputState> {
  formInputName: string[] = ["apiConfig", "apifySettingsId"];

  constructor(props: IConfigApifyInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingApifyId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingApifyId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingApifyId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigApifySettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingApifyId={this.state.editingApifyId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Apify"
          formInputName={this.formInputName}
          options={this.props.commonSettings.apifySettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_Apify"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpApifyDropdown"
          addNewTestId="appSettingsMcpApifyAddNewButton"
          editTestId="appSettingsMcpApifyEditButton"
        />
      </>
    );
  }
}
